// ERRORS-1 Part B: provides the bug-report dialog to the app (see lib/bugReport.ts). A
// pass-through while the `bug_reports` feature is off (FEATURES-1 runtime switch, read from
// `GET /v1/features`), so `useBugReport()` stays null.
import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { BugReportDialog } from './BugReportDialog';
import { BugReportContext, type BugReportPrefill } from '../lib/bugReport';
import { useFeatureEnabled } from '../lib/features';

export function BugReportProvider({ children }: { children: ReactNode }) {
  const [prefill, setPrefill] = useState<BugReportPrefill | null>(null);
  const open = useCallback((p: BugReportPrefill = {}) => setPrefill(p), []);
  const value = useMemo(() => ({ open }), [open]);
  const enabled = useFeatureEnabled('bug_reports');
  // One stable tree whether the switch is on or off: the switch arrives asynchronously
  // (`GET /v1/features`) and can flip at runtime, and swapping the wrapper element would
  // remount the whole app shell underneath it (losing its state).
  return (
    <BugReportContext.Provider value={enabled ? value : null}>
      {children}
      {enabled && prefill && <BugReportDialog prefill={prefill} onClose={() => setPrefill(null)} />}
    </BugReportContext.Provider>
  );
}
